module.exports = __webpack_public_path__ + "img/tractorUnitRearRightOutline.2067da04.svg";